import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { registerInstallEligibilitySW } from "@/pwa/register-sw";

// v3.16-1236 — Suppress the benign "ResizeObserver loop completed with
// undelivered notifications" warning that CRA's dev-mode error overlay
// intercepts. This is a Chrome-only diagnostic message (never crashes
// production, never affects behaviour). Blocking it stops the overlay
// from stealing Playwright click focus during the layout density pass.
if (typeof window !== "undefined") {
  const RESIZE_OBSERVER_RE = /ResizeObserver loop (limit exceeded|completed with undelivered notifications)/;
  window.addEventListener("error", (e) => {
    if (e && typeof e.message === "string" && RESIZE_OBSERVER_RE.test(e.message)) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  });
  window.addEventListener("unhandledrejection", (e) => {
    const msg = e && e.reason && (e.reason.message || String(e.reason));
    if (typeof msg === "string" && RESIZE_OBSERVER_RE.test(msg)) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// v3.18-1277 PWA-003 Phase 1.5 — Register minimum install-eligibility SW.
// Strict passthrough; no caching, no offline. See public/sw.js for details.
registerInstallEligibilitySW();
